import { gdcConverter } from '@gd/currency-converter'

export function formatMoneyAmount(amount: string, currency: string) {
  return gdcConverter(amount, {
    gdc: currency,
  })
}
